// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileAddFilledSvg from "@ant-design/icons-svg/es/asn/FileAddFilled";
import AntdIcon from '../components/AntdIcon';

var FileAddFilled = function FileAddFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileAddFilledSvg
  }));
};

FileAddFilled.displayName = 'FileAddFilled';
export default React.forwardRef(FileAddFilled);